import axios from "axios";

export const createChangeConcept = async (username, conceptVOToCreate) => {
    try {
        const {data} = await axios.post("/api/concept/create", {username, conceptVOToCreate});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const retrieveAllChangeConcepts = async (username) => {
    try {
        const {data} = await axios.get("/api/concept/viewAll?username=" + username);
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const updateChangeConcept = async (username, conceptVOToUpdate) => {
    try {
        const {data} = await axios.put("/api/concept/update", {username, conceptVOToUpdate});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const deleteChangeConcept = async (username, externalReference) => {
    try {
        const {data} = await axios.delete("/api/concept/delete", {data: {username, externalReference}})
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}
